var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('h4',{staticClass:"reg"},[_vm._v(" Add "),_c('span',{staticClass:"bold"},[_vm._v(_vm._s(_setup.indefiniteEntityName))]),_vm._v(" in "),_c('span',{staticClass:"bold"},[_vm._v(_vm._s(_vm.itemName))])])
}
var staticRenderFns = []

export { render, staticRenderFns }